module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_16_J_1.aa9cab08.mp3";